export default "__VITE_ASSET__u6GqZQa3__"